module.exports = __webpack_public_path__ + "static/media/happy-face.cb233450.svg";